import { render } from "./ccCOPPerTemperature.vue?vue&type=template&id=5ec2db18"
import script from "./ccCOPPerTemperature.vue?vue&type=script&lang=js"
export * from "./ccCOPPerTemperature.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Dev\\CCERWB\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__